const CRYPTO_ALPHABET = '⠁⠃⠉⠙⠑⠋⠛⠓⠊⠚⠅⠇⠍⠝⠕⠏⠟⠗⠎⠞⠥⠧⠺⠭⠽⠵⠪⠳⠻⠘';

// Function to check if the elements are ready
function checkElements() {
    const elements = {
        bottomRectangle: document.querySelector('.bottom-rectangle'),
        cryptoContainer: document.querySelector('#crypto-container'),
        scrollText: document.querySelector('#scroll-text-area'),
        cryptoTextElement: document.querySelector('#crypto-text-element'),
        originalTextElement: document.querySelector('#original-text-element')
    };

    // Check if the rectangle is extended
    const isExpanded = elements.bottomRectangle?.classList.contains('expand');

    console.log('DOM Structure:', document.querySelector('.bottom-rectangle')?.innerHTML);

    console.log('DOM Elements check:', {
        bottomRectangle: {
            exists: !!elements.bottomRectangle,
            isExpanded: isExpanded,
            html: elements.bottomRectangle?.innerHTML?.substring(0, 100)
        },
        cryptoContainer: {
            exists: !!elements.cryptoContainer,
            html: elements.cryptoContainer?.innerHTML?.substring(0, 100)
        },
        scrollText: {
            exists: !!elements.scrollText,
            html: elements.scrollText?.innerHTML?.substring(0, 100)
        },
        cryptoTextElement: {
            exists: !!elements.cryptoTextElement,
            html: elements.cryptoTextElement?.innerHTML?.substring(0, 100)
        },
        originalTextElement: {
            exists: !!elements.originalTextElement,
            html: elements.originalTextElement?.innerHTML?.substring(0, 100)
        }
    });

    // Check if all elements exist
    const allExist = Object.values(elements).every(element => element !== null);
    
    if (!allExist || !isExpanded) {
        return false;
    }
    return true;
}


// Export the function to make it available globally
export function initCryptoText() {
    console.log('initCryptoText function called');
    console.log('Current script:', document.currentScript);
    console.log('Document ready state:', document.readyState);

    function logDOMStructure() {
        const bottomRect = document.querySelector('.bottom-rectangle');
        console.log('Bottom Rectangle HTML:', bottomRect ? bottomRect.innerHTML : 'not found');
        
        // Check if the elements exist in the HTML
        console.log('DOM Structure check:', {
            bottomRectangle: document.querySelector('.bottom-rectangle')?.outerHTML,
            cryptoContainer: document.querySelector('#crypto-container')?.outerHTML,
            cryptoContainerByClass: document.querySelector('.crypto-text-container')?.outerHTML,
            scrollText: document.querySelector('#scroll-text-area')?.outerHTML,
            scrollTextByClass: document.querySelector('.scroll-text')?.outerHTML
        });
    }

    // Change the loading DOM condition
    if (document.readyState !== 'complete') {
        console.log('DOM still loading, waiting...');
        document.addEventListener('DOMContentLoaded', initCryptoText);
        return;
    }

    // Strict verification of ASCII initialization
    if (typeof window.asciiEffectInitialized === 'undefined' || !window.asciiEffectInitialized) {
        console.log('Waiting for ASCII effect to initialize...');
        setTimeout(initCryptoText, 100);
        return;
    }

    logDOMStructure();

    const bottomRectangle = document.querySelector('.bottom-rectangle');
    if (!bottomRectangle) {
        console.log('Bottom rectangle not found, retrying...');
        setTimeout(initCryptoText, 100);
        return;
    }

    const isExpanded = bottomRectangle.classList.contains('expand');
    if (!isExpanded) {
        console.log('Bottom rectangle not expanded, retrying...');
        setTimeout(initCryptoText, 100);
        return;
    }

    setTimeout(() => {
        const elements = {
            cryptoContainer: document.querySelector('#crypto-container'),
            scrollText: document.querySelector('#scroll-text-area'),
            cryptoTextElement: document.querySelector('#crypto-text-element'),
            originalTextElement: document.querySelector('#original-text-element')
        };

        console.log('Crypto elements after delay:', elements);

        if (!elements.cryptoContainer || !elements.scrollText || 
            !elements.cryptoTextElement || !elements.originalTextElement) {
            console.log('Elements still missing, retrying...');
            setTimeout(initCryptoText, 100);
            return;
        }
    }, 500)

    // Wait for the elements to be available
    const waitForElements = setInterval(() => {
        const elementsReady = checkElements();
        console.log('Elements ready:', elementsReady);
        
        if (elementsReady) {
            clearInterval(waitForElements);
            console.log('All crypto elements found and ready, initializing...');

            const bottomRectangle = document.querySelector('.bottom-rectangle.expand');
            const cryptoContainer = document.querySelector('#crypto-container');
            const cryptoTextElement = document.querySelector('#crypto-text-element');
            const originalTextElement = document.querySelector('#original-text-element');
            const scrollText = document.querySelector('#scroll-text-area');

            if (cryptoContainer) {
                cryptoContainer.style.display = 'block';
                cryptoContainer.style.visibility = 'visible';
            } else {
                console.error('Crypto container not found');
                return;
            }

            let scrollCount = 0;

            const originalText = originalTextElement.textContent
            .split('\n')
            .map(line => line.trim())
            .join('\n'); 

            function getDeviceScrollMultiplier() {
                const width = window.innerWidth;
                if (width <= 375) return 0.2;
                if (width <= 414) return 0.45;
                if (width <= 480) return 0.8;
                if (width <= 768) return 0.9;
                return 0.5;
            }

            function updateTextWithFade(scrollPercentage) {
                const originalChars = originalText.split('');
                let result = '';
                const deviceMultiplier = getDeviceScrollMultiplier();

                if (window.innerWidth <= 768) {
                    const textPosition = scrollText.scrollTop / (scrollText.scrollHeight - scrollText.clientHeight);
                    const speedMultiplier = textPosition < 0.2 ? 2 :
                                        textPosition < 0.4 ? 1.5 :
                                        textPosition < 0.6 ? 1.1 :
                                        textPosition < 0.8 ? 1 :
                                        textPosition < 0.9 ? 0.85 : 0.80;

                    const progressMultiplier = 1 + (textPosition < 0.3 ? textPosition * 0.5 : textPosition * 0.2);
                    const revealProgress = Math.min(textPosition * speedMultiplier * progressMultiplier, 1);
                    const charsToReveal = Math.max(preRevealedLength, Math.floor(originalChars.length * revealProgress));

                    result = originalChars.map((char, i) => {
                        if (char === ' ' || char === '\n') return char;
                        return i < charsToReveal ? char :
                            CRYPTO_ALPHABET[Math.floor(Math.random() * CRYPTO_ALPHABET.length)];
                    }).join('');

                    if (charsToReveal > 0) {
                        cryptoTextElement.classList.add('decrypted');
                    }

                } else {
                    const speedMultiplier = scrollCount > 2 ? 2.6 :
                                        scrollCount > 3 ? 0.11 : 0.1;
                    const revealProgress = Math.min(scrollPercentage * speedMultiplier * deviceMultiplier, 1);
                    const charsToReveal = Math.max(preRevealedLength, Math.floor(originalChars.length * revealProgress));

                    result = originalChars.map((char, i) => {
                        if (char === ' ' || char === '\n') return char;
                        return i < charsToReveal ? char :
                            CRYPTO_ALPHABET[Math.floor(Math.random() * CRYPTO_ALPHABET.length)];
                    }).join('');

                    if (charsToReveal > 0) {
                        cryptoTextElement.classList.add('decrypted');
                    }
                }

                cryptoTextElement.textContent = result;

                if (scrollPercentage >= 0.99) {
                    cryptoTextElement.textContent = originalText;
                    cryptoTextElement.classList.add('decrypted');
                }
            }

            // Initialize the encrypted text with first 3 lines pre-decrypted
            const lines = originalText.split('\n');
            const preRevealedText = lines.slice(0, 6).join('\n');
            const preRevealedLength = preRevealedText.length;

            cryptoTextElement.textContent = originalText.split('').map((char, i) => {
                if (char === ' ' || char === '\n') return char;
                if (i < preRevealedLength) return char;
                return CRYPTO_ALPHABET[Math.floor(Math.random() * CRYPTO_ALPHABET.length)];
            }).join('');
            cryptoTextElement.classList.add('decrypted');

            // Event listeners
            scrollText.addEventListener('scroll', () => {
                const scrollPercentage = Math.min(1, Math.max(0, 
                    scrollText.scrollTop / (scrollText.scrollHeight - scrollText.clientHeight)
                ));
                scrollCount++;
                updateTextWithFade(scrollPercentage);
            });

            window.addEventListener('resize', () => {
                const scrollPercentage = Math.min(1, Math.max(0, 
                    scrollText.scrollTop / (scrollText.scrollHeight - scrollText.clientHeight)
                ));
                updateTextWithFade(scrollPercentage);
            });
        }
    }, 50);

    setTimeout(() => {
        clearInterval(waitForElements);
    }, 17000);
}

window.initCryptoText = initCryptoText;
console.log('Crypto-text module loaded and attached to window');